import { useState, useEffect } from 'react';

export default function PastEvents() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const events = [
    {
      id: 1,
      image: 'https://static.readdy.ai/image/05c85fc7da3c56350a98e06d6933007c/960a1b7a9a6a10de9221864a7fc386fa.png',
      title: 'Feria Hispánica Tupelo MS',
      date: '2024',
      description: 'Gran evento con Los Armadillos de la Sierra, Grupo Aroma y más artistas'
    },
    {
      id: 2,
      image: 'https://static.readdy.ai/image/05c85fc7da3c56350a98e06d6933007c/ce054fac63dd830c93f1b099a98d2e3d.jpeg',
      title: 'Concierto en Vivo',
      date: '2024',
      description: 'Noche inolvidable con el mejor entretenimiento y producción profesional'
    },
    {
      id: 3,
      image: 'https://static.readdy.ai/image/05c85fc7da3c56350a98e06d6933007c/7f0e4d3d7534485635a0ad363706fc0a.jpeg',
      title: 'Evento Musical',
      date: '2024',
      description: 'Producción profesional con artistas destacados y sonido de primera calidad'
    },
    {
      id: 4,
      image: 'https://static.readdy.ai/image/05c85fc7da3c56350a98e06d6933007c/d3919bc593c5a6ec0a54f9a0da0e87d7.jpeg',
      title: 'Espectaculos musicales',
      date: '2024',
      description: 'Festival con múltiples artistas y producción de primer nivel'
    },
    {
      id: 5,
      image: 'https://public.readdy.ai/ai/img_res/975b1f86b030b423c8cf0a2791dd68f3.jpg',
      title: 'Boda Especial',
      date: '2024',
      description: 'Celebración elegante con música en vivo y sonido profesional'
    },
    {
      id: 6,
      image: 'https://readdy.ai/api/search-image?query=corporate%20event%20with%20professional%20stage%20setup%20modern%20lighting%20system%20business%20conference%20with%20live%20entertainment%20high%20end%20audio%20visual%20equipment%20professional%20production&width=1200&height=800&seq=event-005&orientation=landscape',
      title: 'Evento Corporativo',
      date: '2024',
      description: 'Producción completa para evento empresarial de alto nivel'
    }
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % events.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + events.length) % events.length);
  };

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
  };

  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(interval);
  }, [currentIndex, isAutoPlaying]);

  return (
    <section id="eventos-pasados" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Montserrat',sans-serif] text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Eventos Pasados
          </h2>
          <p className="font-['Poppins',sans-serif] text-base text-gray-600 max-w-2xl mx-auto">
            Revive los mejores momentos de nuestros eventos. Cada producción es una historia de éxito.
          </p>
        </div>

        <div className="relative">
          {/* Carrusel Principal */}
          <div className="relative w-full h-[500px] md:h-[600px] rounded-3xl overflow-hidden shadow-2xl">
            {events.map((event, index) => (
              <div
                key={event.id}
                className={`absolute inset-0 transition-all duration-700 ease-in-out ${
                  index === currentIndex
                    ? 'opacity-100 translate-x-0'
                    : index < currentIndex
                    ? 'opacity-0 -translate-x-full'
                    : 'opacity-0 translate-x-full'
                }`}
              >
                <img
                  src={event.image}
                  alt={event.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
                
                {/* Información del Evento */}
                <div className="absolute bottom-0 left-0 right-0 p-8 md:p-12">
                  <div className="max-w-3xl">
                    <span className="inline-block bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
                      {event.date}
                    </span>
                    <h3 className="font-['Montserrat',sans-serif] text-3xl md:text-4xl font-bold text-white mb-3">
                      {event.title}
                    </h3>
                    <p className="font-['Poppins',sans-serif] text-base text-white/90">
                      {event.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}

            {/* Botones de Navegación */}
            <button
              onClick={() => {
                prevSlide();
                setIsAutoPlaying(false);
              }}
              className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm hover:bg-white/30 rounded-full transition-all cursor-pointer group"
              aria-label="Anterior"
            >
              <i className="ri-arrow-left-s-line text-2xl text-white w-6 h-6 flex items-center justify-center group-hover:scale-110 transition-transform"></i>
            </button>
            <button
              onClick={() => {
                nextSlide();
                setIsAutoPlaying(false);
              }}
              className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm hover:bg-white/30 rounded-full transition-all cursor-pointer group"
              aria-label="Siguiente"
            >
              <i className="ri-arrow-right-s-line text-2xl text-white w-6 h-6 flex items-center justify-center group-hover:scale-110 transition-transform"></i>
            </button>
          </div>

          {/* Indicadores de Puntos */}
          <div className="flex items-center justify-center gap-3 mt-8">
            {events.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`transition-all cursor-pointer ${
                  index === currentIndex
                    ? 'w-12 h-3 bg-teal-600 rounded-full'
                    : 'w-3 h-3 bg-gray-300 hover:bg-gray-400 rounded-full'
                }`}
                aria-label={`Ir al evento ${index + 1}`}
              />
            ))}
          </div>

          {/* Miniaturas */}
          <div className="mt-8 grid grid-cols-2 md:grid-cols-5 gap-4">
            {events.map((event, index) => (
              <button
                key={event.id}
                onClick={() => goToSlide(index)}
                className={`relative w-full h-24 rounded-xl overflow-hidden cursor-pointer transition-all ${
                  index === currentIndex
                    ? 'ring-4 ring-teal-600 scale-105'
                    : 'opacity-60 hover:opacity-100'
                }`}
              >
                <img
                  src={event.image}
                  alt={event.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className={`absolute inset-0 ${
                  index === currentIndex ? 'bg-teal-600/20' : 'bg-black/20'
                }`}></div>
              </button>
            ))}
          </div>
        </div>

        {/* Botón de Contacto */}
        <div className="text-center mt-16">
          <p className="font-['Poppins',sans-serif] text-base text-gray-700 mb-6">
            ¿Quieres que tu evento sea el próximo en esta galería?
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contacto');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-gradient-to-r from-teal-600 to-teal-500 text-white px-8 py-3 rounded-full text-base font-semibold hover:from-teal-700 hover:to-teal-600 transition-all shadow-lg whitespace-nowrap cursor-pointer inline-block transform hover:scale-105"
          >
            Planea tu Evento
          </button>
        </div>
      </div>
    </section>
  );
}
